// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
} from '@mui/material'
import { useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import appInfo from '../../../../configs/app-info';
import { getCustomer, getProduct, getSales } from '../../../../api/helper';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    const [openDialog, setOpenDialog] = useState<boolean>(false)

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/production/permintaan-preview/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setValue('tgl', data.tgl)
                    setValue('link', data.link)
                    setValue('nama_barang', data.nama_barang)
                    setValue('qty_stock', data.qty_stock)
                    setValue('qty_forecast', data.qty_forecast)
                    setValue('qty_request', data.qty_request)
                    setValue('qty_wo', data.qty_wo)
                    setValue('qty_suggested', data.qty_suggested)
                    setValue('qty_hasil', data.qty_hasil)
                    setValue('mmbarang_id', data.mmbarang_id)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    const InfoItem = ({ label, value }: { label: any; value: any }) => (
        <Box sx={{ mb: 1.5 }}>
            <Typography
                sx={{ fontSize: 13, fontWeight: 600, color: "text.secondary", mb: 0.3 }}
            >
                {label}
            </Typography>
            <Typography>
                {value}
            </Typography>
        </Box>
    );

    interface FormInputs {
        mmbarang_id: any,
        tgl: any,
        link: any,
        nama_barang: any,
        qty_stock: any,
        qty_forecast: any,
        qty_request: any,
        qty_wo: any,
        qty_suggested: any,
        qty_hasil: any,
    }

    const defaultValues = {
        nama_barang: null
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        setOpenDialog(false);

        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/production/permintaan-preview/edit-qty-request/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getDetail()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Permintaan Preview 17
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ m: 0, mb: 3 }} />
                    <form>
                        <Grid container spacing={2} sx={{ ml: 3 }}>
                            <Grid item xs={12} md={12}>
                                <Box
                                    sx={{
                                        mb: 2,
                                        p: 2,
                                        borderRadius: 1,
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {watch('link') ? (
                                        <img src={watch('link')} alt="Preview" style={{ maxWidth: '20%' }} />
                                    ) : (
                                        <Typography color="text.secondary">Tidak ada gambar</Typography>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Nama Barang" value={watch("nama_barang")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Qty Stock" value={watch("qty_stock")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Qty Forecast" value={watch("qty_forecast")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                    <InfoItem label="Qty Request" value={watch("qty_request")} />
                                    {watch("qty_wo") == 0 && (
                                        <Tooltip title="Edit">
                                            <IconButton size='small' onClick={() => setOpenDialog(true)}>
                                                <Icon icon='mdi:pencil' />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Qty WO" value={watch("qty_wo")} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InfoItem label="Qty Suggested" value={watch("qty_suggested")} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem label="Qty Hasil" value={watch("qty_hasil")} />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoItem
                                    label="Tanggal"
                                    value={
                                        watch("tgl")
                                            ? new Date(watch("tgl")).toLocaleDateString("id-ID", {
                                                weekday: "long",
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })
                                            : "-"
                                    }
                                />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Edit Quantity Request
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <TextField
                            label="Qty Request"
                            type="number"
                            defaultValue={watch("qty_request")}
                            onChange={(e) => setValue("qty_request", parseInt(e.target.value))}
                            fullWidth
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button variant="contained" color="primary" onClick={() => onSubmit(getValues())}>Simpan</Button>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid >
    )
}
